<template>
  <header class="header-component">
    <dx-toolbar class="header-toolbar">
      <dx-item
        :visible="menuToggleEnabled"
        location="before"
        css-class="menu-button"
      >
        <template #default>
          <dx-button
            icon="menu"
            styling-mode="text"
            @click="toggleMenuFunc"
          />
        </template>
      </dx-item>

      <dx-item
        v-if="title"
        location="before"
        css-class="header-title dx-toolbar-label"
      >
        <div width="400" :title="viewName">{{title}} - {{viewName}}</div>
      </dx-item>

      <dx-item>
        <b ref='statusDiv' style="color:#E70000"> {{ state.value.label }}: {{ state.mode  }} mode </b>
      </dx-item>
      <dx-item>
        <b > - {{ CurrentHour }}</b>
      </dx-item>

      <dx-item
        location="after"
        locate-in-menu="auto"
        menu-item-template="menuUserItem"
      >
        <template #default>
          <div>
            <dx-button
              class="user-button authorization"
              :width="210"
              height="100%"
              styling-mode="text"
            >
              <user-panel :user="user" :menu-items="userMenuItems" menu-mode="context" />
            </dx-button>
          </div>
        </template>
      </dx-item>

      <dx-item
        location="after"
        locate-in-menu="auto">
         <dx-button
            :width="30"
            :height="30"
            position="right"
            :icon="iconFullScreenButton"
            type="normal"
            styling-mode="text"
            :hint="hintText"
            @click="setFullscreen()"
          />
      </dx-item>

      <template #menuUserItem>
        <user-panel
          :user="user"
          :menu-items="userMenuItems"
          menu-mode="list"
        />
      </template>
    </dx-toolbar>
  </header>

 
  <DxPopup
    content-template="help-log-popup"
    title="Help & Info "
    max-width="300px"
    max-height="165px"
    :show-close-button="true"
    v-model:visible="isHelpLogPopupVisible"
    :hide-on-outside-click="true">
    <template #help-log-popup>
      <p>For detailed help and support contact us at <b>  info@enfasys.es</b></p><br/>
      <b>Software version:</b> {{ infoEnfyo.software_version }}
    </template>            
  </DxPopup>

  <DxPopup
    content-template="help-nolog-popup"
    title="Help & Info "
    max-width="300px"
    max-height="110px"
    :show-close-button="true"
    v-model:visible="isHelpNoLogPopupVisible"
    :hide-on-outside-click="true">
    <template #help-nolog-popup>
      For detailed help and support contact us at <b>  info@enfasys.es</b>
    </template>            
  </DxPopup>

</template>

<script>
import DxButton from "devextreme-vue/button";
import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
import { useRouter, useRoute } from 'vue-router';
import { computed, onMounted, onUnmounted, ref, watchEffect, reactive } from 'vue';
import { useStore } from 'vuex';
import RawDataService from '../services/RawDataServiceTemplate';
import { DxPopup } from 'devextreme-vue/popup';
import UserPanel from "./user-panel";
import notify from 'devextreme/ui/notify';

export default {
  props: {
    menuToggleEnabled: Boolean,
    title: String,
    toggleMenuFunc: Function,
    logOutFunc: Function
  },
  setup() {
    const statusDataService = new RawDataService('status/');
    const router = useRouter();
    const route = useRoute();
    const store = useStore();

    const user = store.state.user;
    const viewName = ref("");
    const offlineUserMenu=[
      {
        text: "Help & Info",
        icon: "help",
        onClick: onHelpClick_nolog
      },
      {
        text: "Log In",
        icon: "key",
        onClick: onLoginClick
      }
    ];
    const onlineUserMenu=[
      {
        text: "My Account",
        icon: "user",
        onClick: onProfileClick
      },
      {
        text: "Log Out",
        icon: "runner",
        onClick: onLogoutClick
      },
      {
        text: "Help & Info",
        icon: "help",
        onClick: onHelpClick_log
      },
    ];
    const userMenuItems = computed(() => store.state.loggedIn? onlineUserMenu : offlineUserMenu )
    const userStore = computed(() => store.state.user)
    watchEffect(() => viewName.value=route.name.charAt(0).toUpperCase() + route.name.slice(1) )

    function onLogoutClick() {
      store.dispatch('logOut');
      onLoginClick();
    }
    function onLoginClick() {
      router.push({
        path: "/login-form",
        query: { redirect: route.path }
      });
    }

    const infoEnfyo = ref({software_version:''})
    const isHelpLogPopupVisible = ref(false)
    const isHelpNoLogPopupVisible = ref(false)
    async function onHelpClick_log() {
      const infoDataService = new RawDataService('device/enfyo');
      await infoDataService.getAll().then(res=>{infoEnfyo.value=res})
      isHelpLogPopupVisible.value=true;
    }
     async function onHelpClick_nolog() {
      isHelpNoLogPopupVisible.value=true;
    }

    function onProfileClick() {
      router.push({
        path: "/settings",
        query: { redirect: route.path }
      });
    }
    
    // Time
    const CurrentHour= ref('');
    setInterval(updateTime, 1000);
    updateTime();
    
    function updateTime() {
        var cd = new Date();
        let timezone = store.state.timezone || 'Europe/Madrid'; 
        cd = new Date(cd.toLocaleString('en-US',{timeZone:timezone}))
        CurrentHour.value = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
    }
    function zeroPadding(num, digit) {
        var zero = '';
        for(var i = 0; i < digit; i++) {
            zero += '0';
        }
        return (zero + num).slice(-digit);
    }

    // Status
    const states=[{
      color:'#10D900',//'#82E0AA',
      label:'online'
    },{
      color:'#E70000',
      label:'offline'
    }]
    const state = reactive({
      value: states[1],
      mode: '-'
    });
    const statusDiv =ref()
    let timer;
    
    const checkStatus = async()=>{
      if(typeof statusDiv.value == 'undefined' && statusDiv.value == null )
        return;
      
      try{
        await statusDataService.getAll().then(res=>{
          if(res.isOk){
            state.value=states[0]
            statusDiv.value.style.color=states[0].color
          }else{
            notify('Connection lost', 'error', 4000);
            state.value=states[1]
            console.log('Connection lost')
            statusDiv.value.style.color=states[1].color
          }
          state.mode=res.operationMode;
        })
      } catch(e){
        notify('Error: Connection lost', 'error', 4000);
        console.log('error:'+e.message);
        state.value=states[1]
        statusDiv.value.style.color=states[1].color
      }
    }

    // FULLSCREEN MODE
    const iconFullScreenButton = ref(require('../assets/objects/fullScreen_dark.png')); 
    const hintText = ref('Full Screen')
    var elem = document.documentElement;
    var fullScreenMode = false;
    const setFullscreen = ()=>{

      if (fullScreenMode){
        fullScreenMode = false;
        iconFullScreenButton.value = require('../assets/objects/fullScreen_dark.png'); 
        hintText.value="FullScreen";
        closeFullscreen()
      }else{
        fullScreenMode = true;
        hintText.value = "Exit fullScreen"
        iconFullScreenButton.value = require('../assets/objects/nofullScreen_dark.png'); 
        openFullscreen()
      }
    }

    function openFullscreen() {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }
    }

    function closeFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) { /* Safari */
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) { /* IE11 */
        document.msExitFullscreen();
      }
    }

    // 

    onMounted(()=>{
      checkStatus()
      timer = setInterval(async () => {
        checkStatus()
      }, 5000);
    
    })

    onUnmounted(()=>{
      clearInterval(timer)
    })
    
    

    return {
      viewName,
      user,
      userMenuItems,
      userStore,
      state,
      statusDiv,
      CurrentHour,
      onLogoutClick,
      onLoginClick,
      onHelpClick_log,
      onHelpClick_nolog,
      infoEnfyo,
      isHelpLogPopupVisible,
      isHelpNoLogPopupVisible,
      onProfileClick,

      setFullscreen,
      iconFullScreenButton,
      hintText,
    };
  }
  // watch: {
  //   $route() {
  //     this.viewName = this.$route.name.charAt(0).toUpperCase() + this.$route.name.slice(1)
  //     //console.log(this.viewName)
  //   },
  // },
  ,
  components: {
    DxButton,
    DxToolbar,
    DxItem,
    UserPanel,
    DxPopup
  }
};
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";
@import "../dx-styles.scss";

.header-component {
  flex: 0 0 auto;
  z-index: 1;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

  .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
    color: $base-accent;
  }
}

.dx-toolbar.header-toolbar .dx-toolbar-items-container .dx-toolbar-after {
  padding: 0 10px;

  .screen-x-small & {
    padding: 0 10px;
  }
}

.dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
  width: $side-panel-min-width;
  text-align: center;
  padding: 0;
}

.header-title .dx-item-content {
  padding: 0;
  margin: 0;
}

.dx-theme-generic {
  .dx-toolbar {
    padding: 10px 0;
  }

  .user-button > .dx-button-content {
    padding: 3px;
  }
}
</style>
